import React, { useEffect } from 'react'
import FAQ from './FAQ'
import { Link } from "react-router-dom";
import { Button } from 'antd';

export default function Refund(props) {
    useEffect(() => {
        document.title = "Vabis' Literature Services - Literature Proofreading - Writing your blurb";
        window.scrollTo(0, 0);
    }, [])

    return (
        <div className="App">
            <div className="promotion">&#128218;&#128218;  CLAIM 10 PERCENT OFF NOW USING CODE: <b>10OFF</b> , USE IT ON PAYMENT PAGE  &#128218;&#128218;</div>
            <div className="header-wrapper">
                <img
                    src={'/images/shutterstock_653569309_600.jpg'}
                    srcSet={`/images/shutterstock_653569309_1200.jpg 4000w`}
                    alt="Writing your blurb"
                    style={{float: 'left', width: '100%'}}
                />

                <div className="header-text">
                    <header>
                        <h1>Writing your Blurb</h1>
                    </header>
                    <p>Do you need a succinct yet enticing blurb? Fear not, from only &#163;9.99 let me write you one and let your book make the first good impression it deserves to set. After all, your potential readers are most likely going to flip back your book to read the blurb before purchasing it. No wonder it is said that the first impression is the last impression.</p>
                    <Link to="/request?service=blurb"><Button type="primary">Request to write a Blurb</Button></Link>
                </div>
            </div>

            <div className="content-wrapper">
                <FAQ topic='blurb' />
                <FAQ topic='general' />
            </div>
        </div>
    )

}
